// DFW city landing pages — SEO authority build.
// Each city gets its own live URL at /tx/:slug with unique title, meta, H1, LocalBusiness
// schema, breadcrumb schema, FAQ schema, and local context.

import { NEW_CITIES } from "./dfw-master";

export const DFW_CITIES_CORE = [
  {
    slug: "dallas",
    name: "Dallas",
    county: "Dallas County",
    zip: "75201",
    lat: 32.7767, lng: -96.7970,
    population: "1.3M",
    industries: ["law firms", "auto repair", "medical clinics", "restaurants", "real estate", "salons"],
    nearby: ["highland-park", "university-park", "irving", "garland", "mesquite", "richardson"],
    hook: "Dallas is one of the fastest-moving business markets in the country. If a customer can't reach you in 30 seconds, they move to the next name on Google.",
  },
  {
    slug: "fort-worth",
    name: "Fort Worth",
    county: "Tarrant County",
    zip: "76102",
    lat: 32.7555, lng: -97.3308,
    population: "935K",
    industries: ["auto repair", "contractors", "roofers", "plumbers", "restaurants", "law firms"],
    nearby: ["arlington", "grapevine", "keller", "colleyville", "southlake", "north-richland-hills"],
    hook: "Fort Worth trades on trust and repeat business. Missing calls or slow follow-up costs you the customers your grandfather built the shop on.",
  },
  {
    slug: "arlington",
    name: "Arlington",
    county: "Tarrant County",
    zip: "76010",
    lat: 32.7357, lng: -97.1081,
    population: "395K",
    industries: ["auto shops", "salons", "restaurants", "roofers", "medical clinics"],
    nearby: ["fort-worth", "grand-prairie", "mansfield", "grapevine"],
    hook: "Arlington sits right between Dallas and Fort Worth. If your website doesn't answer visitors 24/7, they close the tab and open a competitor.",
  },
  {
    slug: "plano",
    name: "Plano",
    county: "Collin County",
    zip: "75024",
    lat: 33.0198, lng: -96.6989,
    population: "290K",
    industries: ["law firms", "medical clinics", "fitness studios", "restaurants", "professional services"],
    nearby: ["frisco", "richardson", "allen", "mckinney", "carrollton"],
    hook: "Plano is one of the wealthiest zip codes in Texas. Customers here expect professional websites, instant answers, and clean payment experiences.",
  },
  {
    slug: "frisco",
    name: "Frisco",
    county: "Collin County",
    zip: "75033",
    lat: 33.1507, lng: -96.8236,
    population: "230K",
    industries: ["real estate", "medical", "fitness", "sports academies", "restaurants"],
    nearby: ["plano", "the-colony", "little-elm", "prosper", "mckinney"],
    hook: "Frisco is one of the fastest-growing cities in America. New customers show up every day — but they're only calling businesses that answer.",
  },
  {
    slug: "irving",
    name: "Irving",
    county: "Dallas County",
    zip: "75061",
    lat: 32.8140, lng: -96.9489,
    population: "255K",
    industries: ["logistics", "auto repair", "restaurants", "medical clinics", "law firms"],
    nearby: ["dallas", "las-colinas", "grand-prairie", "farmers-branch", "coppell"],
    hook: "Irving is a hub for corporate offices and small service businesses. Your website is often the first (and only) impression.",
  },
  {
    slug: "garland",
    name: "Garland",
    county: "Dallas County",
    zip: "75040",
    lat: 32.9126, lng: -96.6389,
    population: "240K",
    industries: ["auto shops", "contractors", "restaurants", "salons"],
    nearby: ["mesquite", "sachse", "richardson", "rowlett", "dallas"],
    hook: "Garland runs on blue-collar businesses that live and die by phone calls. One missed call can cost you $2,000 in real work.",
  },
  {
    slug: "grand-prairie",
    name: "Grand Prairie",
    county: "Dallas + Tarrant County",
    zip: "75050",
    lat: 32.7460, lng: -96.9978,
    population: "200K",
    industries: ["auto repair", "roofers", "contractors", "restaurants"],
    nearby: ["arlington", "irving", "dallas", "mansfield"],
    hook: "Grand Prairie sits at the crossroads of DFW. Customers pick between three shops within five miles — the one that answers first, wins.",
  },
  {
    slug: "mckinney",
    name: "McKinney",
    county: "Collin County",
    zip: "75069",
    lat: 33.1972, lng: -96.6398,
    population: "215K",
    industries: ["boutiques", "medical", "law firms", "restaurants", "real estate"],
    nearby: ["frisco", "allen", "plano", "prosper"],
    hook: "McKinney doubled in population since 2010. New homeowners need dentists, mechanics, attorneys, and salons — and they're Googling right now.",
  },
  {
    slug: "denton",
    name: "Denton",
    county: "Denton County",
    zip: "76201",
    lat: 33.2148, lng: -97.1331,
    population: "150K",
    industries: ["contractors", "auto shops", "restaurants", "salons", "medical"],
    nearby: ["lewisville", "flower-mound", "frisco", "highland-village"],
    hook: "Denton is a university town with a real small-business economy. Missing after-hours leads is missing the busiest hours of the week.",
  },
  {
    slug: "carrollton",
    name: "Carrollton",
    county: "Dallas + Denton County",
    zip: "75006",
    lat: 32.9756, lng: -96.8899,
    population: "135K",
    industries: ["restaurants", "medical", "salons", "auto repair"],
    nearby: ["dallas", "farmers-branch", "addison", "coppell", "the-colony"],
    hook: "Carrollton is dense with small owner-operated shops. Every one of them competes with a bigger chain — the local shop with instant follow-up wins.",
  },
  {
    slug: "richardson",
    name: "Richardson",
    county: "Dallas County",
    zip: "75080",
    lat: 32.9483, lng: -96.7299,
    population: "120K",
    industries: ["tech", "medical", "restaurants", "professional services"],
    nearby: ["plano", "garland", "dallas", "highland-park"],
    hook: "Richardson is the Telecom Corridor. Customers here won't wait — they expect instant chat, clean scheduling, and secure payments.",
  },
  {
    slug: "lewisville",
    name: "Lewisville",
    county: "Denton County",
    zip: "75067",
    lat: 33.0462, lng: -96.9942,
    population: "115K",
    industries: ["auto repair", "restaurants", "medical", "salons", "roofers"],
    nearby: ["flower-mound", "the-colony", "coppell", "carrollton"],
    hook: "Lewisville is home to hardworking owners who wear five hats a day. An AI twin gives you back two of them.",
  },
  {
    slug: "flower-mound",
    name: "Flower Mound",
    county: "Denton County",
    zip: "75028",
    lat: 33.0146, lng: -97.0969,
    population: "80K",
    industries: ["medical", "law firms", "restaurants", "boutiques", "fitness"],
    nearby: ["lewisville", "grapevine", "highland-village", "coppell"],
    hook: "Flower Mound is affluent, family-focused, and Google-savvy. Your website has to look and behave like the businesses they're used to.",
  },
  {
    slug: "grapevine",
    name: "Grapevine",
    county: "Tarrant County",
    zip: "76051",
    lat: 32.9343, lng: -97.0781,
    population: "55K",
    industries: ["restaurants", "boutiques", "hospitality", "wineries", "wedding vendors"],
    nearby: ["southlake", "colleyville", "coppell", "flower-mound", "irving"],
    hook: "Grapevine attracts tourists year-round. Your website has to speak to visitors AND locals — often in the same session.",
  },
  {
    slug: "southlake",
    name: "Southlake",
    county: "Tarrant County",
    zip: "76092",
    lat: 32.9412, lng: -97.1342,
    population: "34K",
    industries: ["luxury retail", "medical", "law firms", "real estate", "fitness"],
    nearby: ["colleyville", "keller", "grapevine", "westlake"],
    hook: "Southlake customers judge you in the first three seconds on their phone. If your website feels cheap, you lose them before you can answer.",
  },
];

// Merged export — 16 core + 60 expansion cities = 76 total DFW city landing pages.
export const DFW_CITIES = [...DFW_CITIES_CORE, ...NEW_CITIES];

// Common local FAQs (rendered on every city page for FAQ schema).
export const CITY_FAQS = (city) => [
  {
    q: `How much does a professional website cost in ${city.name}, TX?`,
    a: `A full PlugitAI website with an AI sales agent, forms, scheduling, and payment setup runs under $1,800 depending on scope, with a $299.99 project lock-in. For most ${city.name} small businesses the value comes back in one to two new customers.`,
  },
  {
    q: `How fast can you launch a ${city.name} business website?`,
    a: `Most ${city.name} projects are live in days, not weeks. Once we have your business information, colors, and photos, we begin design immediately and hand you back a working site — usually within the same week.`,
  },
  {
    q: `Do you build websites for ${city.industries[0]} in ${city.name}?`,
    a: `Yes. We build websites and AI sales agents for ${city.industries.slice(0, 4).join(", ")}, and other service businesses in ${city.name} and across the DFW metroplex. Each site is tuned to the industry — not a template.`,
  },
  {
    q: `Will the AI answer calls and messages after hours?`,
    a: `Yes. Your AI twin runs 24/7. It answers website visitors, handles common questions, recognizes buying signals, collects intake information, schedules appointments, and sends the details to you — even when you are closed.`,
  },
  {
    q: `Can you redesign my existing ${city.name} website?`,
    a: `Absolutely. A website facelift is often faster and cheaper than starting over. We audit your current site, fix the parts that lose customers, add the AI sales agent, and clean up the design.`,
  },
];
